import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckWoundAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-wound-slot',
    templateUrl: './check-wound-slot.component.html',
    styleUrl: './check-wound-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckWoundSlotComponent implements SheetSlotComponentBase {

	@Input() action!: CheckWoundAction;
	value = null;

	constructor() {
	}
}